import React from 'react'

const Header = () => {
  return (
    /* < !--==================== NAVBAR ==================== --> */
    < section className="header__section" >

      <header className="header" id="header">

        <nav className="nav__container">

          <div className="logo">
            <a href="#"><img src='images/logo.png' alt="the little stonies logo" /></a>
          </div>

          <div className="nav__burger" id="mobile__menu">
            <div className="hamburger-box">
              <div className="hamburger-inner"></div>
            </div>
          </div>

          <ul className="nav__list">

            <li className="nav__item">
              <a href="#about" className="nav__link link__underline">About</a>
            </li>

            <li className="nav__item">
              <a href="#roadmap" className="nav__link link__underline">Roadmap</a>
            </li>

            <li className="nav__item">
              <a href="#team" className="nav__link link__underline">Team</a>
            </li>

            <li className="nav__item">
              <a href="#faq" className="nav__link link__underline">FAQ</a>
            </li>

            <li className="nav__item">
              <a href="https://little-stonies.gitbook.io/little-stonies/" target="_blank" className="nav__link link__underline" rel="noopener noreferrer">WhitePaper</a>
            </li>

            <li className="nav__item discord">
              <a href="https://discord.gg/RZFuCdSp" target="blank" className="nav__link"><img src="images/discord.png" alt="discord logo" /></a>
            </li>

          </ul>
        </nav>
      </header>
    </section >
  )
}

export default Header;